<script>
import {
  required,
  requiredIf,
  alpha,
  email,
  maxLength,
  minLength,
} from "vuelidate/lib/validators";
import VueDropify from "vue-dropify";
import VueCropper from "vue-cropperjs";
import "cropperjs/dist/cropper.css";
import Multiselect from "vue-multiselect";

// Custom Components and variables OR method
import Map from "@/components/Map.vue";
import DataUpdateInfo from "@/components/dataUpdateInfo.vue";
import { authComputed, authMethods } from "@/state/helpers";
import {
  currency,
  time_zones,
  date_formate,
  time_formate,
  date_time_formate,
} from "@/helpers/global.variable";
import Middleware from "@/helpers/middlewares";
import superService from "@/helpers/APIService/super.service";
import PbxService from "@/helpers/APIService/pbx.service";
import errorHandler from "@/helpers/errorHandler";

const initHotelForm = {
  name: "",
  brand: "",
  currency: "usd",
  address: "",
  zip_code: "",
  city: "",
  state: "",
  country: "",
  email: "",
  phone_number: "",
  front_desk_number: "",
  whatsapp_number: "",
  website: "",
  time_zone: "America/New_York",
  date_format: { text: "MMM-DD-YYYY", value: "MMM-DD-YYYY" },
  time_formate: { text: "HH:MM XM", value: "HH:MM XM" },
  date_time_format: {
    text: "MMM-DD-YYYY HH:MM XM",
    value: "MMM-DD-YYYY HH:MM XM",
  },
  app_theme_color: "",
  latitude: "",
  longitude: "",
  map_location_url: "",
  rating: "",
  stripe_customer_id: "",
  manager_designation: "",
  manager_email: "",
  manager_name: "",
  manager_number: "",
  is_active: true,
  g_place_id: "",
  g_business_detail: {},
};

export default {
  data() {
    return {
      hotel_form: {
        manager_email: "",
        email: "",
      },
      logo: {
        file: null,
        url: "",
        imgURL: "",
      },
      favicon_icon: {
        file: null,
        url: "",
        imgURL: "",
      },
      phone_number_iso: "",
      front_desk_number_iso: "",
      whatsapp_number_iso: "",
      manager_number_iso: "",
      timeZoneOptions: time_zones,
      dateFormateOptions: date_formate,
      timeFormteOptions: time_formate,
      dateTimeFormateOptions: date_time_formate,
      currencyOptions: currency,
      brandOptions: [],
      submitted: false,
      isBtnLoading: false,
      isError: false,
      errorMessage: null,
      isDataSyncing: false,
      dataToBeUpdate: {},
      hotelFormStatus: true,

      // domain data
      pbx_form: {
        select_domain: "",
        sub_domain: "",
        pbx: "",
        ip: "",
        domain_timezone: "",
        extension_limit: "",
        domain_enabled: true,
        domain_uuid: "",
        domain_ip: "",
        domain_name: "",
        stripe_customer_id: "",
        domain_description: "",
        is_active: true,
        domain_subscription: true,
        audiomsg: false,
        audiofile: "",
        push_notification: false,
        dailyvmaildel: false,
        main_cid: "",
        emr_cid: "",
        emr_name: "",
        main_name: "",
        vpn_ip: "",
      },
      tab_domain: "new-domain",
      main_domain: { text: "cloudext.co", value: "cloudext.co" },
      designation: ["Manager", "Owner"],
      ip_whitelisted: "--",
      select_domain_options: [],
      select_domain_options_copy: [],
      pbx_options: [],
      brandList: [],
      hotelID: "",
      domainLoading: false,
      hotelData: null,
      hotelFormData: null,
    };
  },
  components: {
    Map,
    DataUpdateInfo,
    VueDropify,
    VueCropper,
    Multiselect,
  },
  validations: {
    hotel_form: {
      name: { required },
      brand: { required },
      currency: { required },
      email: { required, email },
      front_desk_number: { required },
      manager_email: { email },
    },
    pbx_form: {
      select_domain: { required },
      pbx: { required },
      domain_timezone: { required },
      extension_limit: { required },
      main_cid: { required, minLength: minLength(10) },
      main_name: { required },
      emr_cid: { required, minLength: minLength(10) },
      emr_name: { required },
      sub_domain: {
        required: requiredIf(function () {
          if (this.tab_domain == "new-domain") {
            return true;
          }
        }),
        alpha,
        maxLength: maxLength(15),
        minLength: minLength(5),
      },
    },
  },
  props: {
    hotelDetails: Object,
    isEdit: Boolean,
    hotelId: String,
  },
  emits: ["cancelSubmit", "submitted"],
  computed: {
    ...authComputed,
  },
  mounted() {
    this.getHotel();
    this.getBrandedData();
    this.setValue();
  },
  methods: {
    ...authMethods,
    // Method is use for get hotel details
    async getHotel() {
      if (this.isEdit && this.hotelDetails !== null) {
        this.hotelData = this.hotelDetails.hotel_data;

        console.log(this.hotel_form, "this.hotelData");
        Object.keys(this.hotelData).map((key) => {
          if (
            this.hotelData[key] !== null &&
            this.hotelData[key] !== undefined
          ) {
            this.hotel_form[key] = this.hotelData[key];
          }

          if (key == "favicon_icon") {
            this.favicon_icon.url = this.hotelData[key];
          }
          if (key == "logo") {
            this.logo.url = this.hotelData[key];
          }

          if (key == "rating") {
            this.hotel_form[key] = Math.floor(JSON.parse(this.hotelData[key]));
          }

          if (key == "manager_designation") {
            this.hotel_form[key] = this.hotelData[key];
          }

          if (key == "date_format") {
            this.hotel_form[key] = {
              value: this.hotelData[key],
              text: this.hotelData[key],
            };
          }
          if (key == "date_time_format") {
            this.hotel_form[key] = {
              value: this.hotelData[key],
              text: this.hotelData[key],
            };
          }
          if (key == "time_formate") {
            this.hotel_form[key] = {
              value: this.hotelData[key],
              text: this.hotelData[key],
            };
          }
        });

        this.dataToBeUpdate = {
          created_by: this.hotelDetails.created_by,
          created_at: this.hotelDetails.created_at,
          updated_by: this.hotelDetails.updated_by,
          updated_at: this.hotelDetails.updated_at,
        };
      } else {
        this.hotel_form = initHotelForm;
      }
    },
    // Method is use for add and updated hotel details
    onSubmit() {
      this.submitted = true;
      this.isBtnLoading = true;
      this.isError = false;
      this.$v.hotel_form.$touch();
      if (this.$v.hotel_form.$invalid) {
        this.isBtnLoading = false;
        return;
      } else {
        let hotelFormData = new FormData();
        delete this.hotel_form.favicon_icon;
        delete this.hotel_form.logo;
        this.hotel_form.brand = this.hotel_form.brand.value;
        this.hotel_form.date_format = this.hotel_form.date_format.value;
        this.hotel_form.time_formate = this.hotel_form.time_formate.value;
        this.hotel_form.date_time_format =
          this.hotel_form.date_time_format.value;
        Object.keys(this.hotel_form).map((key) => {
          if (
            this.hotel_form[key] !== null &&
            this.hotel_form[key] !== undefined
          ) {
            if (this.isEdit) {
              if (this.hotel_form[key] !== this.hotelData[key])
                hotelFormData.append(key, this.hotel_form[key]);
            } else {
              hotelFormData.append(key, this.hotel_form[key]);
            }
          }
        });
        if (this.logo.file != null || "") {
          hotelFormData.append(
            "logo",
            this.createImageFromBase(
              this.$refs.cropper.getCroppedCanvas().toDataURL(),
              "logo.jpg"
            )
          );
        }
        if (this.favicon_icon.file != null || "") {
          hotelFormData.append(
            "favicon_icon",
            this.createImageFromBase(
              this.$refs.cropper.getCroppedCanvas().toDataURL(),
              "favicon_icon.jpg"
            )
          );
        }
        if (this.phone_number_iso !== "")
          hotelFormData.append("phone_number_iso", this.phone_number_iso);
        if (this.front_desk_number_iso !== "")
          hotelFormData.append(
            "front_desk_number_iso",
            this.front_desk_number_iso
          );
        if (this.front_desk_number_iso !== "")
          hotelFormData.append(
            "front_desk_number_iso",
            this.front_desk_number_iso
          );
        hotelFormData.append("front_desk_email", this.hotel_form.email);

        this.pbx_form.domain_timezone = this.hotel_form.time_zone;
        this.hotelFormData = hotelFormData;
        superService
          .filtetrHotel(
            `?or_email=${this.hotel_form.email}&or_g_place_id=${this.hotel_form.g_place_id}&or_front_desk_number=${this.hotel_form.front_desk_number}`
          )
          .then((response) => {
            if (response.length !== 0) {
              this.hotelFormStatus = true;
              return Middleware.notification(
                "Hotel record with give infomation already exist.",
                "info",
                5000
              );
            } else {
              this.hotelFormStatus = false;
            }
          })
          .catch((error) => {
            this.isBtnLoading = false;
            this.hotel_form = initHotelForm;
            errorHandler(error);
            if (error.response.status !== 500) {
              this.isError = true;
              this.errorMessage = error.response.data;
            }
          });
        this.isBtnLoading = false;
      }
    },
    // Method is used to cancel form submission
    cancelSubmition() {
      this.hotel_form = initHotelForm;
      this.$emit("cancelSubmit");
    },
    // Method is use for update and maintained favicon icon
    changeFavicon(event) {
      if (event[0] !== undefined) {
        this.favicon_icon.file = event[0] == undefined ? null : event[0];
        this.favicon_icon.imgURL = URL.createObjectURL(event[0]);
      } else {
        this.favicon_icon.file = null;
        this.favicon_icon.url = "";
        this.favicon_icon.imgURL = "";
      }
    },
    // Method is use for update and maintained logo icon
    changeLogo(event) {
      if (event[0] !== undefined) {
        this.logo.file = event[0] == undefined ? null : event[0];
        this.logo.imgURL = URL.createObjectURL(event[0]);
      } else {
        this.logo.file = null;
        this.logo.url = "";
        this.logo.imgURL = "";
      }
    },
    // Method is use for maintained and mange country change
    countryChange(phone_type, code) {
      switch (phone_type) {
        case "phone_number":
          this.phone_number_iso = code.iso2;
          break;
        case "front_desk_number":
          this.front_desk_number_iso = code.iso2;
          break;
        case "whatsapp_number":
          this.whatsapp_number_iso = code.iso2;
          break;
        case "manager_number":
          this.manager_number_iso = code.iso2;
          break;
      }
    },
    // Method is used to get brand list data
    async getBrandedData() {
      this.isDataLoading = true;
      try {
        const brands = await superService.getBrandData();
        if (brands) {
          this.brandList = brands;
          brands.map((brand) => {
            if (this.isEdit && this.hotelData != null) {
              if (this.hotelData.brand_id == brand.id) {
                this.hotelData.brand = {
                  text: brand.name,
                  value: brand.id,
                };
              }
            }
            this.brandOptions.push({ text: brand.name, value: brand.id });
          });
        }
      } catch (error) {
        errorHandler(error);
      }
    },
    // Method is use for convert base64 file into file
    createImageFromBase(dataUrl, filename) {
      var arr = dataUrl.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);

      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }

      return new File([u8arr], filename, { type: mime });
    },
    // Method is used to handle search result
    async setPlace(place) {
      console.log(place, "place");
      let forDetails = [];
      let googleData = place;
      const lat = place.geometry.location.lat();
      const lng = place.geometry.location.lng();
      googleData = { ...googleData, latitude: lat, longitude: lng };
      for (
        let index = 0;
        index < googleData.address_components.length;
        index++
      ) {
        const element = googleData.address_components[index];
        forDetails.push(element);
      }

      // To get Location Details like city, state, country etc.
      for (let index = 0; index < forDetails.length; index++) {
        const element = forDetails[index];
        if (element.types[0] == "country") {
          this.hotel_form.country = element.long_name;
        }
        if (element.types[0] == "administrative_area_level_1") {
          this.hotel_form.state = element.short_name;
        }
        if (element.types[0] == "administrative_area_level_2") {
          this.hotel_form.city = element.long_name;
        } else if (element.types[0] == "administrative_area_level_3") {
          this.hotel_form.city = element.long_name;
        }
        if (element.types[0] == "postal_code") {
          this.hotel_form.zip_code = element.long_name;
        }
        if (element.types[0] == "street_number") {
          this.hotel_form.address = element.long_name;
        }
        if (element.types[0] == "route") {
          this.hotel_form.address += `, ${element.long_name}`;
        }
      }
      this.hotel_form.g_place_id = googleData.place_id;
      this.hotel_form.latitude = googleData.latitude;
      this.hotel_form.longitude = googleData.longitude;
      this.hotel_form.front_desk_number = googleData.international_phone_number
        ? googleData.international_phone_number
        : "";
      this.hotel_form.name = googleData.name ? googleData.name : "";
      this.hotel_form.website = googleData.website ? googleData.website : "";
      this.hotel_form.rating = Math.floor(googleData.rating);
      this.hotel_form.map_location_url = googleData.url;
      this.hotel_form.g_business_detail = googleData;
    },
    // Method is used to handle brand change
    brandChange(brand) {
      this.brandList.forEach((element) => {
        if (brand.value == element.id) {
          if (element.logo != null) {
            this.logo.imgURL = element.logo;
          }
          if (element.favicon_icon != null) {
            this.favicon_icon.imgURL = element.favicon_icon;
          }
        }
      });
    },

    // DOMAIN METHODs

    // Method is used to get Domain list
    async setValue() {
      try {
        const response = await PbxService.getDomainList();
        if (response) {
          response.forEach((element) => {
            if (!String(element.domain_name).match(/\d/g)) {
              this.select_domain_options_copy.push({
                value: element.domain_uuid,
                text: element.domain_name,
              });
            }
          });
        }
      } catch (error) {
        errorHandler(error);
      }
      // Method is used to get Pbx Server List
      try {
        const pbxresponse = await PbxService.getPBXServerList();
        pbxresponse.result.forEach((element) => {
          this.pbx_options.push({
            value: element.server_ip,
            text: element.server_name,
            item: element,
          });
        });
        this.domainLoading = false;
        if (this.isEdit && this.hotelDetails !== null) {
          this.select_domain_options = this.select_domain_options_copy;
          this.tab_domain = "existing-domain";
          this.update_domain(this.hotelDetails.domain_uuid);
        } else {
          this.pbx_form.select_domain = this.main_domain;
          this.select_domain_options = [
            { text: "cloudext.co", value: "cloudext.co" },
          ];
        }
      } catch (error) {
        errorHandler(error);
      }
    },
    // On domain select
    onChange(event) {
      if (event == "new-domain") {
        Object.keys(this.pbx_form).map((key) => {
          if (this.pbx_form[key] !== null && this.pbx_form[key] !== undefined) {
            this.pbx_form[key] = "";
          }
        });
        this.select_domain_options = [
          { text: "cloudext.co", value: "cloudext.co" },
        ];
        this.pbx_form.select_domain = this.main_domain;
      } else {
        this.select_domain_options = this.select_domain_options_copy;
      }
    },
    // Select Domain And Update input filed
    update_domain(domain_uuid) {
      if (domain_uuid == undefined) return;
      this.domainLoading = true;
      let domainId =
        typeof domain_uuid == "string" ? domain_uuid : domain_uuid.value;
      PbxService.getDomainDetailList(domainId)
        .then((res) => {
          this.domainLoading = false;
          this.pbx_form = res;
          this.pbx_form.domain_ip = res.ip;
          this.pbx_form.pbx = { text: res.pbx, value: res.ip };
          this.pbx_form.extension_limit = res.extension_limit;
          this.pbx_form.select_domain = {
            value: res.domain_uuid,
            text: res.domain_name,
          };
        })
        .catch((error) => {
          this.domainLoading = false;
          errorHandler(error);
        });
    },
    // Select PBX Server And Update input filed
    update_server() {
      let pbxobj = this.pbx_form.pbx;
      this.pbx_options.forEach((element) => {
        if (pbxobj.value == element.value) {
          this.pbx_form.ip = element.item.server_ip;
        }
      });
      if (this.isEdit == false && this.tab_domain == "new-domain") {
        this.pbx_form.domain_name =
          String(this.pbx_form.sub_domain).toLowerCase() +
          "." +
          this.pbx_form.select_domain.value;
      }
    },
    // Method is used to handle submit form
    onDomainSubmit() {
      this.submitted = true;
      this.isBtnLoading = true;
      this.$v.pbx_form.$touch();
      if (this.$v.pbx_form.$invalid) {
        this.isBtnLoading = false;
        return;
      } else {
        if (this.tab_domain == "new-domain") {
          const domain_name =
            this.pbx_form.sub_domain + "." + this.pbx_form.select_domain.value;
          const data = {
            domain_name: domain_name,
            domain_enabled: true,
            domain_description: this.pbx_form.domain_description,
            pbx: this.pbx_form.pbx.text,
            ip: this.pbx_form.ip,
            domain_timezone: this.pbx_form.domain_timezone,
            stripe_customer_id: this.pbx_form.stripe_customer_id,
            domain_subscription:
              this.pbx_form.domain_subscription == true ? "active" : "",
            main_cid: this.pbx_form.main_cid,
            main_name: this.pbx_form.main_name,
            emr_cid: this.pbx_form.emr_cid,
            emr_name: this.pbx_form.emr_name,
            vpn_ip: this.pbx_form.vpn_ip,
            audiomsg: this.pbx_form.audiomsg,
            audiofile: this.pbx_form.audiofile,
            dailyvmaildel: this.pbx_form.dailyvmaildel,
            staffauth: "",
            vm_admin_pin: this.pbx_form.vm_admin_pin,
            extension_limit: this.pbx_form.extension_limit,
          };
          PbxService.addDomainDetail(data)
            .then((response) => {
              this.isBtnLoading = false;
              if (response.status == false) {
                return Middleware.notification(response.message, "danger");
              }
              superService.updateHotel(this.hotelID, {
                pbx_domain_name: response.result.domain_name,
                pbx_domain_uuid: response.result.domain_uuid,
              });
              Middleware.notification(
                "Domain successfully updated !!",
                "success"
              );
            })
            .catch((error) => {
              this.isError = true;
              this.isBtnLoading = false;
              this.errorMessage = error.response.data;
              errorHandler(error);
            });
        } else {
          PbxService.updateDomainDetail(this.pbx_form.domain_uuid, {
            domain_name: this.pbx_form.domain_name,
            domain_enabled: true,
            domain_description: this.pbx_form.domain_description,
            pbx:
              typeof this.pbx_form == "string"
                ? this.pbx_form
                : this.pbx_form.pbx.value,
            ip: this.pbx_form.ip,
            domain_timezone: this.pbx_form.domain_timezone,
            stripe_customer_id: this.pbx_form.stripe_customer_id,
            domain_subscription: this.pbx_form.domain_subscription,
            main_cid: this.pbx_form.main_cid,
            main_name: this.pbx_form.main_name,
            emr_cid: this.pbx_form.emr_cid,
            emr_name: this.pbx_form.emr_name,
            vpn_ip: this.pbx_form.vpn_ip,
            audiomsg: this.pbx_form.audiomsg,
            audiofile: this.pbx_form.audiofile,
            dailyvmaildel: this.pbx_form.dailyvmaildel,
            staffauth: this.pbx_form.staffauth,
            roomblock: this.pbx_form.roomblock,
            vm_admin_pin: this.pbx_form.vm_admin_pin,
            extension_limit: this.pbx_form.extension_limit,
          })
            .then((response) => {
              this.isBtnLoading = false;
              if (response.status == false) {
                return Middleware.notification(response.message, "warning");
              }
              Middleware.notification(
                "Domain successfully updated !!",
                "success"
              );
            })
            .catch((error) => {
              this.isError = true;
              this.isBtnLoading = false;
              this.errorMessage = error.response.data;
              errorHandler(error);
            });
        }
        if (this.hotelFormData) {
          if (this.isEdit) {
            superService
              .updateHotel(this.hotelData.id, this.hotelFormData)
              .then((response) => {
                this.isBtnLoading = false;
                Middleware.notification(
                  "Hotel successfully updated !!",
                  "success"
                );
                this.hotelID = response.id;
                this.hotelFormStatus = false;
                this.$emit("submitted", "submitted");
              })
              .catch((error) => {
                this.isBtnLoading = false;
                this.hotel_form = initHotelForm;
                errorHandler(error);
                if (error.response.status !== 500) {
                  this.isError = true;
                  this.errorMessage = error.response.data;
                }
              });
          } else {
            superService
              .addHotel(this.hotelFormData)
              .then((response) => {
                this.isBtnLoading = false;
                Middleware.notification(
                  "Hotel successfully added !!",
                  "success"
                );
                this.hotelID = response.id;
                this.hotelFormStatus = false;
                this.$emit("submitted", "submitted");
              })
              .catch((error) => {
                this.isBtnLoading = false;
                errorHandler(error);
                if (error.response.status !== 500) {
                  this.isError = true;
                  this.errorMessage = error.response.data;
                }
              });
          }
        }
      }
    },
    // Method is use for cancel to add new building
    cancelSubmit() {
      this.$emit("cancelSubmit");
    },
  },
};
</script>

<template>
  <div class="container-fluid">
    <div class="row" v-show="hotelFormStatus">
      <div class="col-12">
        <div class="d-flex align-items-center justify-content-between">
          <h4>{{ isEdit ? "Update" : "Add" }} Customer Details</h4>
        </div>
        <hr />
      </div>
      <div class="col-md-12">
        <div class="row">
          <!-- Basic Details -->
          <div class="col-md-10">
            <div class="position-relative mb-3">
              <Map class="w-100" @update:place="setPlace"></Map>
            </div>
          </div>
          <div class="col-md-12">
            <h4 class="card-title">Basic Details</h4>
            <hr />
          </div>
          <div class="col-md-3">
            <b-form-group class="mb-3" label-for="hotel-name-input">
              <span slot="label">
                Name <span class="text-danger">*</span>
              </span>
              <b-form-input
                id="hotel-name-input"
                type="text"
                autocomplete="off"
                v-model="hotel_form.name"
                :class="{
                  'is-invalid': submitted && $v.hotel_form.name.$error,
                }"
              ></b-form-input>
              <div
                v-if="submitted && $v.hotel_form.name.$error"
                class="invalid-feedback"
              >
                <span v-if="!$v.hotel_form.name.required">
                  Name is required.
                </span>
              </div>
            </b-form-group>
          </div>

          <div class="col-md-3">
            <b-form-group class="mb-3" label-for="brand-input">
              <span slot="label">
                Brand <span class="text-danger">*</span>
              </span>
              <multiselect
                v-model="hotel_form.brand"
                :options="brandOptions"
                :show-labels="false"
                @input="brandChange($event)"
                placeholder="Search band"
                label="text"
                track-by="value"
                :class="{
                  'is-invalid': submitted && $v.hotel_form.brand.$error,
                }"
              ></multiselect>
              <div
                v-if="submitted && $v.hotel_form.brand.$error"
                class="invalid-feedback"
              >
                <span v-if="!$v.hotel_form.brand.required">
                  Brand is required.
                </span>
              </div>
            </b-form-group>
          </div>
          <div class="col-md-4">
            <b-form-group
              class="mb-3 form-label"
              id="input-group-1"
              label-for="rating-input"
            >
              <span slot="label">
                Rating <span class="text-danger">*</span>
              </span>
              <div class="rating-input">
                <div class="star-rating">
                  <input
                    type="radio"
                    id="5-stars"
                    name="rating"
                    value="5"
                    v-model="hotel_form.rating"
                  />
                  <label for="5-stars" class="star">&#9733;</label>
                  <input
                    type="radio"
                    id="4-stars"
                    name="rating"
                    value="4"
                    v-model="hotel_form.rating"
                  />

                  <label for="4-stars" class="star">&#9733;</label>
                  <input
                    type="radio"
                    id="3-stars"
                    name="rating"
                    value="3"
                    v-model="hotel_form.rating"
                  />
                  <label for="3-stars" class="star">&#9733;</label>
                  <input
                    type="radio"
                    id="2-stars"
                    name="rating"
                    value="2"
                    v-model="hotel_form.rating"
                  />
                  <label for="2-stars" class="star">&#9733;</label>
                  <input
                    type="radio"
                    id="1-star"
                    name="rating"
                    value="1"
                    v-model="hotel_form.rating"
                  />
                  <label for="1-star" class="star">&#9733;</label>
                </div>
              </div>
            </b-form-group>
          </div>
          <div class="col-md-3">
            <b-form-group
              class="mb-3 form-label"
              id="input-group-1"
              label-for="currency-input"
            >
              <span slot="label">
                Currency <span class="text-danger">*</span>
              </span>
              <b-form-select
                class="form-select"
                id="currency-input"
                type="text"
                autocomplete="off"
                v-model="hotel_form.currency"
                :options="currencyOptions"
                :class="{
                  'is-invalid': submitted && $v.hotel_form.currency.$error,
                }"
              >
              </b-form-select>
              <div
                v-if="submitted && $v.hotel_form.currency.$error"
                class="invalid-feedback"
              >
                <span v-if="!$v.hotel_form.currency.required">
                  Currency is required.
                </span>
              </div>
            </b-form-group>
          </div>

          <div class="col-md-3">
            <b-form-group
              class="mb-3 form-label"
              id="input-group-1"
              label-for="stripe_customer_id-input"
            >
              <span slot="label"> Strip Customer Id </span>
              <b-form-input
                id="stripe_customer_id-input"
                type="text"
                autocomplete="off"
                v-model="hotel_form.stripe_customer_id"
              >
              </b-form-input>
            </b-form-group>
          </div>

          <!-- Address Details -->
          <div class="col-md-12">
            <h4 class="card-title">Address Information</h4>
            <hr />
          </div>
          <div class="col-md-3">
            <b-form-group class="mb-3" label-for="address-input">
              <span slot="label">
                Address <span class="text-danger">*</span></span
              >
              <b-form-textarea
                id="address-input"
                placeholder="Enter Address..."
                v-model="hotel_form.address"
                required
              ></b-form-textarea>
            </b-form-group>
          </div>
          <div class="col-md-3 col-sm-6">
            <b-form-group class="mb-3" label-for="city-input">
              <span slot="label">
                City
                <span class="text-danger">*</span>
              </span>
              <b-form-input
                id="city-input"
                type="text"
                autocomplete="off"
                v-model="hotel_form.city"
                required
              ></b-form-input>
            </b-form-group>
          </div>
          <div class="col-lg-2 col-sm-4">
            <b-form-group class="mb-3" label-for="state-input">
              <span slot="label">
                State
                <span class="text-danger">*</span>
              </span>
              <b-form-input
                id="state-input"
                type="text"
                autocomplete="off"
                v-model="hotel_form.state"
                required
              ></b-form-input>
            </b-form-group>
          </div>
          <div class="col-md-2 col-sm-6">
            <b-form-group class="mb-3" label-for="zip-code-input">
              <span slot="label">
                Zip Code
                <span class="text-danger">*</span>
              </span>
              <b-form-input
                id="zip-code-input"
                type="text"
                autocomplete="off"
                v-model="hotel_form.zip_code"
                required
              ></b-form-input>
            </b-form-group>
          </div>

          <div class="col-lg-2 col-sm-4">
            <b-form-group class="mb-3" label-for="country-input">
              <span slot="label">
                Country
                <span class="text-danger">*</span>
              </span>
              <b-form-input
                id="country-input"
                type="text"
                autocomplete="off"
                v-model="hotel_form.country"
                required
              ></b-form-input>
            </b-form-group>
          </div>
          <div class="col-lg-2 col-sm-4">
            <b-form-group class="mb-3" label-for="latitude-input">
              <span slot="label">
                Latitude
                <span class="text-danger">*</span>
              </span>
              <b-form-input
                id="latitude-input"
                type="text"
                autocomplete="off"
                v-model="hotel_form.latitude"
                required
              ></b-form-input>
            </b-form-group>
          </div>
          <div class="col-lg-2 col-sm-4">
            <b-form-group class="mb-3" label-for="longitude-input">
              <span slot="label">
                Longitude <span class="text-danger">*</span>
              </span>
              <b-form-input
                id="longitude-input"
                type="text"
                autocomplete="off"
                v-model="hotel_form.longitude"
                required
              ></b-form-input>
            </b-form-group>
          </div>
          <div class="col-md-8">
            <b-form-group class="mb-3" label-for="map_location_url-input">
              <span slot="label"> Map Location Url </span>
              <b-form-input
                id="map_location_url-input"
                type="url"
                autocomplete="off"
                v-model="hotel_form.map_location_url"
              ></b-form-input>
            </b-form-group>
          </div>

          <!-- Contact Details -->
          <div class="col-md-12">
            <h4 class="card-title">Contact Details</h4>
            <hr />
          </div>
          <div class="col-lg-6 col-md-6 col-sm-6">
            <b-form-group
              class="mb-3 form-label"
              id="input-group-1"
              label-for="email-input"
            >
              <span slot="label">
                Front desk Email <span class="text-danger">*</span>
              </span>
              <b-form-input
                id="email-input"
                type="email"
                autocomplete="off"
                v-model="hotel_form.email"
                :class="{
                  'is-invalid': submitted && $v.hotel_form.email.$error,
                }"
              ></b-form-input>
              <div
                v-if="submitted && $v.hotel_form.email.$error"
                class="invalid-feedback"
              >
                <span v-if="!$v.hotel_form.email.required">
                  Email is required.
                </span>
                <span v-if="!$v.hotel_form.email.email">
                  Enter valid email.
                </span>
              </div>
            </b-form-group>
          </div>

          <div class="col-lg-3 col-md-4 col-sm-6">
            <label class="form-label">
              Front Desk Tel
              <span class="text-danger">*</span>
            </label>
            <vue-tel-input
              class="text-dark-gray"
              v-model="hotel_form.front_desk_number"
              :defaultCountry="
                hotelData
                  ? hotelData.front_desk_number_iso !== null
                    ? hotelData.front_desk_number_iso
                    : 'US'
                  : 'US'
              "
              :validCharactersOnly="true"
              @country-changed="
                countryChange('front_desk_number', ...arguments)
              "
              :class="{
                'is-invalid':
                  submitted && $v.hotel_form.front_desk_number.$error,
              }"
            >
            </vue-tel-input>
            <div
              v-if="submitted && $v.hotel_form.front_desk_number.$error"
              class="invalid-feedback"
            >
              <span v-if="!$v.hotel_form.front_desk_number.required">
                Number is required.
              </span>
            </div>
          </div>
          <div class="col-lg-3 col-md-4 col-sm-6">
            <label class="form-label">Whatsapp No</label>
            <vue-tel-input
              class="text-dark-gray"
              v-model="hotel_form.whatsapp_number"
              :validCharactersOnly="true"
              :defaultCountry="
                hotelData
                  ? hotelData.whatsapp_number_iso !== null
                    ? hotelData.whatsapp_number_iso
                    : 'US'
                  : 'US'
              "
              @country-changed="countryChange('whatsapp_number', ...arguments)"
            ></vue-tel-input>
          </div>

          <div class="col-12">
            <b-form-group
              class="mb-3 form-label"
              id="input-group-1"
              label-for="website-input"
            >
              <span slot="label"> Website </span>
              <b-form-input
                id="website-input"
                type="url"
                autocomplete="off"
                v-model="hotel_form.website"
              ></b-form-input>
            </b-form-group>
          </div>

          <!-- Manager Details -->
          <div class="col-md-12">
            <h4 class="card-title">Manager Details</h4>
            <hr />
          </div>
          <div class="col-lg-3 col-md-4 col-sm-6">
            <b-form-group
              class="mb-3 form-label"
              id="input-group-1"
              label-for="name-input"
            >
              <span slot="label"> Name </span>
              <b-form-input
                id="name-input"
                type="text"
                autocomplete="off"
                v-model="hotel_form.manager_name"
              ></b-form-input>
            </b-form-group>
          </div>
          <div class="col-lg-3 col-md-4 col-sm-6">
            <b-form-group class="mb-3" label-for="brand-input">
              <span slot="label"> Designation </span>
              <b-form-select
                class="form-select"
                id="designation-input"
                :options="designation"
                v-model="hotel_form.manager_designation"
                type="text"
                autocomplete="off"
              ></b-form-select>
            </b-form-group>
          </div>
          <div class="col-lg-3 col-md-4 col-sm-6">
            <b-form-group
              class="mb-3 form-label"
              id="input-group-1"
              label-for="email-input"
            >
              <span slot="label"> Email </span>
              <b-form-input
                id="name-input"
                type="email"
                autocomplete="off"
                v-model="hotel_form.manager_email"
                :class="{
                  'is-invalid': submitted && $v.hotel_form.manager_email.$error,
                }"
              ></b-form-input>
              <div
                v-if="submitted && $v.hotel_form.manager_email.$error"
                class="invalid-feedback"
              >
                <span v-if="!$v.hotel_form.manager_email.email">
                  Enter valid email.
                </span>
              </div>
            </b-form-group>
          </div>
          <div class="col-lg-3 col-md-4 col-sm-6 mb-3">
            <label class="form-label">Number</label>
            <vue-tel-input
              class="text-dark-gray"
              v-model="hotel_form.manager_number"
              :validCharactersOnly="true"
              :defaultCountry="
                hotelDetails
                  ? hotelDetails.manager_number_iso !== null
                    ? hotelDetails.manager_number_iso
                    : 'US'
                  : 'US'
              "
              @country-changed="countryChange('manager_number', ...arguments)"
            ></vue-tel-input>
          </div>

          <!-- Time related Details -->
          <div class="col-md-12">
            <h4 class="card-title">Time zone Information</h4>
            <hr />
          </div>
          <div class="col-lg-3 col-md-4 col-sm-6">
            <b-form-group
              class="mb-3 form-label"
              id="input-group-1"
              label-for="time-zone-input"
            >
              <span slot="label"> Time Zone </span>
              <b-form-select
                class="form-select"
                id="time-zone-input"
                :options="timeZoneOptions"
                v-model="hotel_form.time_zone"
                type="text"
                autocomplete="off"
              ></b-form-select>
            </b-form-group>
          </div>
          <div class="col-lg-3 col-md-4 col-sm-6">
            <b-form-group
              class="mb-3 form-label"
              id="input-group-1"
              label-for="date-formate-input"
            >
              <span slot="label"> Date Format </span>
              <multiselect
                :options="dateFormateOptions"
                v-model="hotel_form.date_format"
                :show-labels="false"
                placeholder="Search band"
                label="text"
                track-by="value"
                id="date-formate-input"
              >
              </multiselect>
            </b-form-group>
          </div>
          <div class="col-lg-3 col-md-4 col-sm-6">
            <b-form-group
              class="mb-3 form-label"
              id="input-group-1"
              label-for="time-formate-input"
            >
              <span slot="label"> Time Formate </span>
              <multiselect
                :options="timeFormteOptions"
                v-model="hotel_form.time_formate"
                :show-labels="false"
                placeholder="Search band"
                label="text"
                track-by="value"
                id="time-formate-input"
              >
              </multiselect>
            </b-form-group>
          </div>
          <div class="col-lg-3 col-md-4 col-sm-6">
            <b-form-group
              class="mb-3 form-label"
              id="input-group-1"
              label-for="date-time-formate-input"
            >
              <span slot="label"> Date Time Format </span>
              <multiselect
                :options="dateTimeFormateOptions"
                v-model="hotel_form.date_time_format"
                :show-labels="false"
                placeholder="Search band"
                label="text"
                track-by="value"
                id="date-time-formate-input"
              ></multiselect>
            </b-form-group>
          </div>

          <!-- Other Details -->
          <div class="col-md-12">
            <h4 class="card-title">Other Details</h4>
            <hr />
          </div>
          <div class="col-md-6">
            <label for="logo" class="form-label">Logo</label>
            <VueDropify
              v-if="logo.imgURL == ''"
              @upload="changeLogo($event)"
              :src="logo.url"
              message="Drop image here or click to select"
              class="w-100"
            />
            <vue-cropper
              v-else
              ref="cropper"
              :src="logo.imgURL"
              alt="Source Image"
              class="position-relative w-100"
              :minCropBoxWidth="200"
              :minCropBoxHeight="200"
            >
            </vue-cropper>
          </div>
          <div class="col-md-6">
            <label for="favicon" class="form-label">Favicon</label>
            <VueDropify
              v-if="favicon_icon.imgURL == ''"
              @upload="changeFavicon($event)"
              :src="favicon_icon.url"
              message="Drop image here or click to select"
            />
            <vue-cropper
              v-else
              ref="cropper"
              :src="favicon_icon.imgURL"
              alt="Source Image"
              class="position-relative w-100"
              :minCropBoxWidth="200"
              :minCropBoxHeight="200"
            >
            </vue-cropper>
          </div>
          <div class="col-lg-3 col-md-4 col-sm-5 col-7">
            <div class="d-flex align-items-center mt-3">
              <b-form-input
                class="form-control-color me-2 w-25"
                id="theam_color"
                type="color"
                name="theam_color"
                v-model="hotel_form.app_theme_color"
              ></b-form-input>

              <b-form-input
                class="form-control-color form-color-input w-100"
                id="theam_color"
                type="text"
                v-model="hotel_form.app_theme_color"
              ></b-form-input>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-12">
        <b-alert v-if="isError" show variant="danger">
          <ul>
            <li v-for="(error, index) in errorMessage" :key="index">
              {{ index }}: {{ error[0] }}
            </li>
          </ul>
        </b-alert>
      </div>
      <div class="col-md-12">
        <b-button
          variant="primary"
          class="float-end ms-2 mb-3"
          type="reset"
          @click="cancelSubmition()"
        >
          Cancel
        </b-button>
        <b-button
          variant="primary"
          class="float-end mb-3"
          type="submit"
          :class="{ disabled: isBtnLoading }"
          @click="onSubmit"
        >
          <i
            class="bx bx-loader bx-spin font-size-16 align-middle me-2"
            v-if="isBtnLoading"
          >
          </i>
          Next
        </b-button>
      </div>
      <DataUpdateInfo :data-to-be-show="dataToBeUpdate" />
    </div>

    <div v-show="!hotelFormStatus">
      <b-form @submit.prevent="onDomainSubmit">
        <div class="row">
          <!-- Domain Details -->
          <h4 class="card-title">
            Domain Details
            <b-spinner
              v-if="domainLoading"
              class="ms-2"
              small
              variant="primary"
              label="Spinning"
            ></b-spinner>
          </h4>
          <hr />
          <div class="col-md-12" v-if="!isEdit">
            <b-form-group class="mb-3" label-for="pbx_serve">
              <span slot="label">
                Create Customer With <span class="text-danger">*</span>
              </span>
              <div class="row">
                <div class="col-md-2">
                  <b-form-radio
                    v-model="tab_domain"
                    name="new_domain"
                    value="new-domain"
                    @change="onChange($event)"
                  >
                    <span class="ms-2"> New Domain </span>
                  </b-form-radio>
                </div>
                <div class="col-5">
                  <b-form-radio
                    v-model="tab_domain"
                    name="existing_domain"
                    value="existing-domain"
                    @change="onChange($event)"
                  >
                    <span class="ms-2"> Existing Domain </span>
                    <small v-if="pbx_form.domain_uuid != ''">
                      ({{ pbx_form.domain_uuid }})
                    </small>
                  </b-form-radio>
                </div>
              </div>
            </b-form-group>
          </div>
          <div class="col-md-4">
            <b-form-group class="mb-3" label-for="select-domain">
              <span slot="label">
                <span v-if="tab_domain == 'new-domain'">Select </span> Domain
                <span class="text-danger">*</span>
              </span>
              <multiselect
                v-model="pbx_form.select_domain"
                :options="select_domain_options"
                @input="update_domain"
                :allow-empty="false"
                :show-labels="false"
                placeholder="Search Domain"
                label="text"
                track-by="value"
                id="select-domain"
                :class="{
                  'is-invalid': submitted && $v.pbx_form.select_domain.$error,
                }"
              ></multiselect>
              <div
                v-if="submitted && $v.pbx_form.select_domain.$error"
                class="invalid-feedback"
              >
                <span v-if="!$v.pbx_form.select_domain.required">
                  Select Domain is required.
                </span>
              </div>
            </b-form-group>
          </div>
          <div class="col-md-4" v-if="tab_domain == 'new-domain'">
            <b-form-group class="mb-3" label-for="sub_domain">
              <span slot="label">
                Sub Domain Name <span class="text-danger">*</span></span
              >
              <div class="row mx-1 align-items-end">
                <b-form-input
                  id="sub_domain"
                  type="text"
                  autocomplete="off"
                  v-model="pbx_form.sub_domain"
                  class="col-auto"
                  :class="{
                    'is-invalid': submitted && $v.pbx_form.sub_domain.$error,
                  }"
                ></b-form-input>
                <span class="col-auto text-dark"
                  >.{{ pbx_form.select_domain ? "cloudext.co" : "" }}</span
                >
                <div
                  v-if="submitted && $v.pbx_form.sub_domain.$error"
                  class="invalid-feedback"
                >
                  <span v-if="!$v.pbx_form.sub_domain.required">
                    Domain name is required.
                  </span>
                  <span v-if="!$v.pbx_form.sub_domain.alpha">
                    Domain name must be alpha.
                  </span>
                  <span v-if="!$v.pbx_form.sub_domain.maxLength">
                    Domain name not be more then 15 charecter.
                  </span>
                  <span v-if="!$v.pbx_form.sub_domain.minLength">
                    Domain name not be less than 5 charecter.
                  </span>
                </div>
              </div>
            </b-form-group>
          </div>
          <div class="col-md-4">
            <b-form-group class="mb-3" label-for="select-server">
              <span slot="label">
                Select Server <span class="text-danger">*</span>
              </span>
              <multiselect
                v-model="pbx_form.pbx"
                :options="pbx_options"
                @input="update_server"
                :show-labels="false"
                placeholder="Search Server"
                label="text"
                track-by="value"
                id="select-server"
                :class="{
                  'is-invalid': submitted && $v.pbx_form.pbx.$error,
                }"
              ></multiselect>

              <div
                v-if="submitted && $v.pbx_form.pbx.$error"
                class="invalid-feedback"
              >
                <span v-if="!$v.pbx_form.pbx.required"
                  >Select Server is required.
                </span>
              </div>
            </b-form-group>
          </div>
          <div class="col-md-4">
            <b-form-group class="mb-3" label-for="ip">
              <span slot="label">
                <span v-if="tab_domain == 'new-domain'">Server </span> Ip
                <span class="text-danger">*</span></span
              >
              <b-form-input
                id="ip"
                type="text"
                autocomplete="off"
                v-model="pbx_form.ip"
                readonly
                disabled
              ></b-form-input>
            </b-form-group>
          </div>
          <div class="col-md-4">
            <b-form-group
              class="mb-3 form-label"
              id="input-group-1"
              label-for="time-zone-input"
            >
              <span slot="label"> Timezone </span>
              <b-form-select
                class="form-select"
                id="time-zone-input"
                :options="timeZoneOptions"
                v-model="pbx_form.domain_timezone"
                type="text"
                autocomplete="off"
              ></b-form-select>
              <div v-if="submitted" class="invalid-feedback">
                <span v-if="!$v.pbx_form.domain_timezone.required">
                  Time Zone is required.
                </span>
              </div>
            </b-form-group>
          </div>
          <div class="col-md-4">
            <b-form-group class="mb-3" label-for="extension_limit">
              <span slot="label">
                Extension Limit
                <span class="text-danger">*</span>
              </span>
              <b-form-input
                id="extension_limit"
                type="number"
                autocomplete="off"
                v-model="pbx_form.extension_limit"
                :class="{
                  'is-invalid': submitted && $v.pbx_form.extension_limit.$error,
                }"
              ></b-form-input>
              <div v-if="submitted" class="invalid-feedback">
                <span v-if="!$v.pbx_form.extension_limit.required">
                  Extension Limit is required.
                </span>
              </div>
            </b-form-group>
          </div>
          <div class="col-md-8">
            <b-form-group class="mb-3" label-for="address-input">
              <span slot="label"> Description </span>
              <b-form-textarea
                id="description"
                v-model="pbx_form.domain_description"
              ></b-form-textarea>
            </b-form-group>
          </div>

          <!-- Default Settings -->
          <h4 class="card-title">Default Settings</h4>
          <hr />

          <div class="col-md-6">
            <b-form-group class="mb-3" label-for="main_cid">
              <span slot="label">
                Outbound Caller ID <span class="text-danger">*</span></span
              >
              <b-form-input
                id="main_cid"
                type="number"
                autocomplete="off"
                v-model="pbx_form.main_cid"
                :class="{
                  'is-invalid': submitted && $v.pbx_form.main_cid.$error,
                }"
              ></b-form-input>
              <div
                v-if="submitted && $v.pbx_form.main_cid.$error"
                class="invalid-feedback"
              >
                <span v-if="!$v.pbx_form.main_cid.required">
                  Outbound call id is required.
                </span>
                <span v-if="!$v.pbx_form.main_cid.minLength">
                  Outbound call id not be less than 10 number.
                </span>
              </div>
            </b-form-group>
          </div>
          <div class="col-md-6">
            <b-form-group class="mb-3" label-for="main_cid">
              <span slot="label">
                Outbound Caller Name <span class="text-danger">*</span></span
              >
              <b-form-input
                id="main_name"
                type="text"
                autocomplete="off"
                v-model="pbx_form.main_name"
                :class="{
                  'is-invalid': submitted && $v.pbx_form.main_name.$error,
                }"
              ></b-form-input>
              <div
                v-if="submitted && $v.pbx_form.main_name.$error"
                class="invalid-feedback"
              >
                <span v-if="!$v.pbx_form.main_name.required">
                  Outbound call name is required.
                </span>
              </div>
            </b-form-group>
          </div>
          <div class="col-md-6">
            <b-form-group class="mb-3" label-for="emr_cid">
              <span slot="label">
                Emergency Caller ID <span class="text-danger">*</span></span
              >
              <b-form-input
                id="emr_cid"
                type="number"
                autocomplete="off"
                v-model="pbx_form.emr_cid"
                :class="{
                  'is-invalid': submitted && $v.pbx_form.emr_cid.$error,
                }"
              ></b-form-input>
              <div
                v-if="submitted && $v.pbx_form.emr_cid.$error"
                class="invalid-feedback"
              >
                <span v-if="!$v.pbx_form.emr_cid.required">
                  Emergency call id is required.
                </span>
                <span v-if="!$v.pbx_form.emr_cid.minLength">
                  Emergency call id not be less than 10 number.
                </span>
              </div>
            </b-form-group>
          </div>
          <div class="col-md-6">
            <b-form-group class="mb-3" label-for="emr_name">
              <span slot="label">
                Emergency Caller Name <span class="text-danger">*</span></span
              >
              <b-form-input
                id="emr_name"
                type="text"
                autocomplete="off"
                v-model="pbx_form.emr_name"
                :class="{
                  'is-invalid': submitted && $v.pbx_form.emr_name.$error,
                }"
              ></b-form-input>
              <div
                v-if="submitted && $v.pbx_form.emr_name.$error"
                class="invalid-feedback"
              >
                <span v-if="!$v.pbx_form.emr_name.required">
                  Emergency call nmae is required.
                </span>
              </div>
            </b-form-group>
          </div>
          <div class="col-md-4">
            <b-form-group class="mb-3" label-for="vpn_ip">
              <span slot="label"> VPN IP </span>
              <b-form-input
                id="vpn_ip"
                type="text"
                autocomplete="off"
                v-model="pbx_form.vpn_ip"
              ></b-form-input>
            </b-form-group>
          </div>
          <div class="col-md-4">
            <b-form-group class="mb-3" label-for="vm_admin_pin">
              <span slot="label"> Admin Pin </span>
              <b-form-input
                id="vm_admin_pin"
                type="text"
                autocomplete="off"
                v-model="pbx_form.vm_admin_pin"
              ></b-form-input>
            </b-form-group>
          </div>
          <div class="col-md-3">
            <div class="mb-3">
              <label
                for="dailyvmaildel"
                v-b-popover.hover.top="'Daily VoiceMail Delete'"
                >Daily VoiceMail Delete</label
              >
              <div class="form-check form-switch my-1" slot="dailyvmaildel">
                <input
                  class="form-check-input"
                  id="dailyvmaildel"
                  type="checkbox"
                  v-model="pbx_form.dailyvmaildel"
                />
              </div>
            </div>
          </div>
          <div class="col-md-12">
            <b-alert v-if="isError" show variant="danger">
              <ul>
                <li v-for="(error, index) in errorMessage" :key="index">
                  {{ index }}: {{ error[0] }}
                </li>
              </ul>
            </b-alert>
          </div>
          <hr />

          <div class="col-md-12">
            <b-button
              class="float-end ms-2"
              variant="outline-primary"
              type="reset"
              @click="cancelSubmit"
              >Cancel</b-button
            >
            <b-button
              class="float-end"
              variant="outline-primary"
              type="submit"
              :class="{
                disabled: isBtnLoading,
              }"
            >
              <i
                class="bx bx-loader bx-spin font-size-16 align-middle me-2"
                v-if="isBtnLoading"
              ></i>
              {{ this.isEdit ? "Update" : "Save" }}
            </b-button>
          </div>
        </div>
      </b-form>
    </div>
  </div>
</template>

<style>
.star-rating {
  display: flex;
  flex-direction: row-reverse;
  font-size: 1.5em;
  justify-content: space-between;
  text-align: center;
}

.star-rating input {
  display: none;
}

.star-rating label {
  color: #ccc;
  cursor: pointer;
  margin: 0;
  font-size: 40px;
  line-height: 0.8;
}

.star-rating :checked ~ label {
  color: #fc0;
}

.star-rating label:hover,
.star-rating label:hover ~ label {
  color: #f90;
}
</style>
